<template>
  <div class="pt-2 rounded">
    <!-- <b-overlay
      id="overlay-background"
      show
      variant="transparent"
      :opacity="1"
      blur="1rem"
      rounded="sm"
      no-center
    > -->
    <!-- <template #overlay> -->
    <!-- <span></span>
      </template> -->
    <b-row>
      <b-col cols="12" class="d-flex">
        <line-chart class="w-100" />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6" cols="12" class="d-flex">
        <radar-chart class="w-100" />
      </b-col>
      <b-col md="6" cols="12" class="d-flex">
        <average-skills class="w-100" />
      </b-col>
    </b-row>

    <!-- </b-overlay> -->
  </div>
</template>

<script>
import { BRow, BCol, BOverlay } from "bootstrap-vue";
import LineChart from "./LineChart.vue";
import RadarChart from "./RadarChart.vue";
import AverageSkills from "./AverageSkills.vue";
export default {
  components: {
    BRow,
    BCol,
    BOverlay,
    LineChart,
    RadarChart,
    AverageSkills,
  },
};
</script>

<style>
@supports (-moz-appearance: none) {
  .b-overlay > div {
    background-color: #fffffff2 !important;
    opacity: 0.1;
  }
}
</style>
